module.exports = __webpack_public_path__ + "img/cargo.c5133d2.png";